import { type Dispatch, type SetStateAction } from "react";
import { ActionButtonIntent } from "widgets";

import type { ConfirmationOptions } from "@/services/ConfirmationServiceProvider.tsx";

// Global variables to store the state setter function
let setConfirmationState: Dispatch<SetStateAction<ConfirmationOptions | null>> | null = null;

/**
 * Function to be called in your ConfirmationServiceProvider to set up the global reference
 */
export const initializeConfirmationService = (
  stateSetter: Dispatch<SetStateAction<ConfirmationOptions | null>> | null,
) => {
  setConfirmationState = stateSetter;
};

/**
 * Simple Yes/No confirmation dialog without secondary button
 * Opens the dialog immediately
 */
export const showConfirmationDialog = (options: Omit<ConfirmationOptions, "secondaryButton">) => {
  if (!setConfirmationState) {
    console.error("Confirmation service not initialized. Make sure the provider is mounted.");
    return;
  }

  // Open dialog immediately with configured options
  setConfirmationState({
    ...options,
    mainButton: { intent: ActionButtonIntent.Primary, ...options.mainButton },
    secondaryButton: undefined,
  });
};

/**
 * Confirmation dialog with a secondary button for potentially 'dangerous' actions
 * Opens the dialog immediately
 */
export const showAlertDialog = (options: ConfirmationOptions) => {
  if (!setConfirmationState) {
    console.error("Confirmation service not initialized. Make sure the provider is mounted.");
    return;
  }

  // Open dialog immediately with configured options
  setConfirmationState({
    ...options,
    mainButton: { ...options.mainButton, intent: ActionButtonIntent.Primary },
    secondaryButton: options.secondaryButton
      ? { ...options.secondaryButton, intent: ActionButtonIntent.Danger }
      : undefined,
  });
};
